import React from 'react';

const SharedWithFDADisclaimer = () => {
  return <span className='shared-with-fda-disclaimer'>This report has been shared with FDA.</span>;
};

export default SharedWithFDADisclaimer;
